// extracted by mini-css-extract-plugin
module.exports = {"base":"column-m__base__2bcY8","ad-slot":"column-m__ad-slot__1CjRZ"};